import api from "@/lib/axios";

export const caregiverPerfApi = {
    list: (params) =>
        api
            .get("/caregiver-performance/list", { params, timeout: 90000 })
            .then((r) => r.data),
    getDetail: (caregiverId, params) =>
        api
            .get(`/caregiver-performance/${caregiverId}`, {
                params,
                timeout: 90000,
            })
            .then((r) => r.data),
    getPeer: (caregiverId, params) =>
        api
            .get(`/caregiver-performance/${caregiverId}/peer`, {
                params,
                timeout: 90000,
            })
            .then((r) => r.data),
    generateNarrative: (caregiverId, params) =>
        api
            .post(`/caregiver-performance/${caregiverId}/narrative`, null, {
                params,
            })
            .then((r) => r.data),
    downloadPdf: async (caregiverId, body) => {
        const resp = await api.post(
            `/caregiver-performance/${caregiverId}/pdf`,
            body,
            { responseType: "blob" },
        );
        const disp =
            resp.headers?.["content-disposition"] ||
            resp.headers?.get?.("content-disposition") ||
            "";
        const match = /filename\s*=\s*"?([^";]+)"?/i.exec(disp);
        const filename = match
            ? match[1]
            : `CaregiverPerf_${caregiverId}.pdf`;
        return { blob: resp.data, filename };
    },
};
